// extracted by mini-css-extract-plugin
export default {"logo_preview":"style_logo_preview__cj5dr","mobile_logo_size":"style_mobile_logo_size__ch8uJ"};